<div *nzModalTitle>{{ 'Compare fabrics' | t }}</div>

<div class="compare-modal">
  <div class="compare-grid" [style.--col-count]="fabricUUIDs.length">
    <ng-container *ngIf="loading(); else compareDataRows">
      <div class="compare-row compare-row--header">
        <div class="compare-cell compare-cell--label"></div>
        <div class="compare-cell compare-cell--fabric" *ngFor="let _ of fabricUUIDs">
          <div class="compare-loading-header">
            <nz-spin nzSimple></nz-spin>
            <span>{{ 'Loading fabrics...' | t }}</span>
          </div>
        </div>
      </div>

      <div class="compare-row" *ngFor="let label of compareRowLabels">
        <div class="compare-cell compare-cell--label">{{ label | t }}</div>
        <div class="compare-cell compare-cell--fabric" *ngFor="let _ of fabricUUIDs">
          <div class="compare-loading-line" aria-hidden="true"></div>
        </div>
      </div>
    </ng-container>

    <ng-template #compareDataRows>
      <!-- ─── IMAGE ROW ─── -->
      <div class="compare-row compare-row--header">
        <!-- Label cell -->
        <div class="compare-cell compare-cell--label"></div>
        <!-- Fabric cells -->
        <div class="compare-cell compare-cell--fabric" *ngFor="let fabric of fabrics">
          <a [routerLink]="['/fabrics', fabric.uuid]" (click)="close()">
            <img
              nz-image
              class="compare-cover"
              [nzSrc]="fabric.article?.cover?.cardUrl ?? 'error'"
              [nzFallback]="fallback"
              [alt]="fabric.article?.name"
              [nzDisablePreview]="true"
              width="120"
              height="120"
            />
          </a>
          <a class="compare-fabric-link" [routerLink]="['/fabrics', fabric.uuid]" (click)="close()">
            <span class="compare-fabric-code">{{ fabric.auxCode }}</span>
            <span class="compare-fabric-name">{{ fabric.article?.name || '-' }}</span>
          </a>
        </div>
      </div>

      <!-- ─── PRICE ─── -->
      <div class="compare-row">
        <div class="compare-cell compare-cell--label">{{ 'Price range' | t }}</div>
        <div class="compare-cell compare-cell--fabric" *ngFor="let fabric of fabrics">
          @if (fabric.priceRange.min === fabric.priceRange.max) {
            {{ fabric.priceRange.min | customCurrency: i18n.locale() }}
          } @else {
            {{ fabric.priceRange.min | customCurrency: i18n.locale() }}
            –
            {{ fabric.priceRange.max | customCurrency: i18n.locale() }}
          }
        </div>
      </div>

      <!-- ─── STRUCTURE ─── -->
      <div class="compare-row">
        <div class="compare-cell compare-cell--label">{{ 'Structure' | t }}</div>
        <div class="compare-cell compare-cell--fabric" *ngFor="let fabric of fabrics">
          {{ fabric.rawFabric?.structure?.name || '-' }}
        </div>
      </div>

      <!-- ─── WEAVING TYPE ─── -->
      <div class="compare-row">
        <div class="compare-cell compare-cell--label">{{ 'Weaving type' | t }}</div>
        <div class="compare-cell compare-cell--fabric" *ngFor="let fabric of fabrics">
          {{ fabric.rawFabric?.weavingType?.name || '-' }}
        </div>
      </div>

      <!-- ─── WEIGHT ─── -->
      <div class="compare-row">
        <div class="compare-cell compare-cell--label">{{ 'Weight (+/- 5%)' | t }}</div>
        <div class="compare-cell compare-cell--fabric" *ngFor="let fabric of fabrics">
          {{ fabric.weight || '-' }} g/m²
        </div>
      </div>

      <!-- ─── WIDTH ─── -->
      <div class="compare-row">
        <div class="compare-cell compare-cell--label">{{ 'Width (+/- 5%)' | t }}</div>
        <div class="compare-cell compare-cell--fabric" *ngFor="let fabric of fabrics">
          {{ fabric.width || '-' }} cm
        </div>
      </div>

      <!-- ─── FABRIC STATE ─── -->
      <div class="compare-row">
        <div class="compare-cell compare-cell--label">{{ 'Fabric state' | t }}</div>
        <div class="compare-cell compare-cell--fabric" *ngFor="let fabric of fabrics">
          {{ fabric.fabricState?.name || '-' }}
        </div>
      </div>

      <!-- ─── COLOR ─── -->
      <div class="compare-row">
        <div class="compare-cell compare-cell--label">{{ 'Color' | t }}</div>
        <div class="compare-cell compare-cell--fabric" *ngFor="let fabric of fabrics">
          {{ (fabric?.print?.printDesign?.code ?? fabric.color?.name) || '-' }}
        </div>
      </div>

      <!-- ─── MOQ ─── -->
      <div class="compare-row">
        <div class="compare-cell compare-cell--label">{{ 'MOQ' | t }}</div>
        <div class="compare-cell compare-cell--fabric" *ngFor="let fabric of fabrics">
          {{ fabric.article?.moq ?? '-' }} m
        </div>
      </div>

      <!-- ─── COMPOSITION ─── -->
      <div class="compare-row">
        <div class="compare-cell compare-cell--label">{{ 'Composition' | t }}</div>
        <div class="compare-cell compare-cell--fabric" *ngFor="let fabric of fabrics">
          {{ fabric.article?.smallCompositionText || '-' }}
        </div>
      </div>

      <!-- ─── DESCRIPTION ─── -->
      <!-- <div class="compare-row compare-row--tall">
        <div class="compare-cell compare-cell--label">{{ 'Description' | t }}</div>
        <div class="compare-cell compare-cell--fabric" *ngFor="let fabric of fabrics">
          {{ getDescription(fabric) }}
        </div>
      </div> -->

      <!-- ─── WASH CARE ─── -->
      <div class="compare-row compare-row--symbols">
        <div class="compare-cell compare-cell--label">{{ 'Wash care' | t }}</div>
        <div class="compare-cell compare-cell--fabric" *ngFor="let fabric of fabrics">
          <ng-container *ngIf="getCleanInstructions(fabric).length; else noSymbols">
            <div class="symbol-list">
              <img
                *ngFor="let clean of getCleanInstructions(fabric)"
                [nzSrc]="clean.symbol?.thumbUrl ?? 'error'"
                [alt]="clean.description | t"
                nz-image
                width="25"
                height="25"
              />
            </div>
          </ng-container>
          <ng-template #noSymbols>
            <span class="muted">-</span>
          </ng-template>
        </div>
      </div>

      <!-- ─── CERTIFICATIONS ─── -->
      <div class="compare-row">
        <div class="compare-cell compare-cell--label">{{ 'Certifications' | t }}</div>
        <div class="compare-cell compare-cell--fabric" *ngFor="let fabric of fabrics">
          <ng-container *ngIf="getCertificationAcronyms(fabric).length; else noCerts">
            <div class="chip-list">
              <span class="chip" *ngFor="let acronym of getCertificationAcronyms(fabric)">
                {{ acronym }}
              </span>
            </div>
          </ng-container>
          <ng-template #noCerts>
            <span class="muted">-</span>
          </ng-template>
        </div>
      </div>
    </ng-template>
  </div>
</div>
